import React from 'react';

import { env } from 'app/utils/env';

type Props = {
  children: React.ReactNode;
};

type Config = {
  env: string;
  appUrl: string;
  apiUrl: string;
  amplitudeKey?: string;
  stripeKey: string;
};

export const config: Config = {
  env: env.env,
  appUrl: env.appUrl,
  apiUrl: env.apiUrl,
  amplitudeKey: env.amplitudeKey,
  stripeKey: env.stripeKey,
};

export const ConfigContext = React.createContext<Config | undefined>(config);

export const ConfigContextProvider = ({ children }: Props) => {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};
